<div class="container-fluid app-shell" style="--bs-gutter-x: 0rem !important;">
    <app-spinner [show]="true" [ngClass]="{'showSpinner': isShowSpinner, 'hideSpinner': !isShowSpinner}"></app-spinner>
    <router-outlet></router-outlet>
</div>

